import React, { useEffect } from 'react';
import { X } from 'lucide-react';
import './AboutModal.css';

interface AboutModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const AboutModal: React.FC<AboutModalProps> = ({ isOpen, onClose }) => {
  useEffect(() => {
    if (!isOpen) return;
    const handleKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    document.addEventListener('keydown', handleKey);
    return () => document.removeEventListener('keydown', handleKey);
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  return (
    <div className="about-modal-overlay" onClick={onClose}>
      <div className="about-modal" onClick={(e) => e.stopPropagation()}>
        <button className="about-modal-close" onClick={onClose} aria-label="Close">
          <X size={18} />
        </button>

        {/* App identity — centered logo + ARCOS name */}
        <div className="about-modal-header">
          <img src="/logo_arcos.webp" alt="ARCOS" className="about-modal-logo" />
        </div>

        <p className="about-modal-appname">ARCOS</p>

        <hr className="about-modal-divider" />

        {/* DHC section */}
        <p className="about-modal-initiative">
          Digital Health Corner — where curiosity meets collaboration.
        </p>

        <hr className="about-modal-divider" />

        <div className="about-modal-authors">
          <p className="about-modal-authors-title">Created by</p>
          <ul>
            <li><strong>Sven Giegerich</strong> — German Armed Forces</li>
            <li><strong>Mohamad Haji</strong> — Belgian Defence</li>
          </ul>
        </div>

        <hr className="about-modal-divider" />

        <p className="about-modal-desc">
          ARCOS is a digital tool for exercise support, structuring international medical
          coordination and evacuation workflows between participating nations.
        </p>

        <div className="about-modal-footer">
          <button className="btn btn-secondary" onClick={onClose}>Close</button>
        </div>
      </div>
    </div>
  );
};

export default AboutModal;
